import { SET_SIDE_NAV, FETCH_SIDE_NAV } from '../actions/types';

export default function reducerSideNav(state = true, action) {
  switch (action.type) {
    case FETCH_SIDE_NAV:
    case SET_SIDE_NAV:
      return action.payload;
    default:
      return state;
  }
}
